
import store from '@/store'
import {
  //setMunicipalitiesDropdown,
  setGridOperatorsFromMunicipalities,
  setCpos,
  setContractorsFromStakeholders,
  setWorkflowUsersDropdown,
  setCharchingStationVersions
} from '@/services/dynamicFormHelpers'
import router from '../router'
import { finUnit, gridConnectionValues } from '@/config';
import { getGridOperators } from '@/services/gridoperators';
import { SPV } from '@/components/asset/assetUtilities'
import i18n from '@/plugins/i18n';

const facetOptions = {
  tags: ({ facets }) => store.getters['tenant/getExistingTags']
    .filter(tag => facets[tag.uuid])
    .map(tag => ({ value: tag.uuid, label: tag.label, count: facets[tag.uuid] })),

  municipality: ({ facets }) => store.getters['tenant/getMunicipalityOptions']
    .filter(opt => facets[opt.value])
    .map(opt => ({ value: opt.value, label: opt.text, count: facets[opt.value] })),

  gridOperator: ({ facets }) => getGridOperators
    .filter(opt => facets[opt.value])
    .map(opt => ({ value: opt.value, label: opt.text, count: facets[opt.value] })),
}

const sort = (array, keyValuePair, sortBy) => {
  const sortField  = sortBy || 'label'
  if (!array) return

  return array.sort((a, b) => keyValuePair
    ? a[sortField].localeCompare(b[sortField])
    : a.localeCompare(b)
  )
}
const setMunicipalityDropdown = (municipalities, keyValuePair, singleValue) => { // singleValue => b.v. Assets municipalities => the value is municipality name //
  return municipalities.filter(mun => mun.text).map(mun => keyValuePair ? { value: singleValue ? mun.text : mun.value, label: mun.text } : mun.text)
}

const municipalityOptions = (keyValuePair, singleValue) => {
  const tenantMunicipalityOptions = store.getters['tenant/getMunicipalityOptions']
  const municipalityOptions = setMunicipalityDropdown(tenantMunicipalityOptions, keyValuePair, singleValue)

  return sort(municipalityOptions, keyValuePair)
}

const municipality = (keyValuePair, singleValue) => {
  return municipalityOptions(keyValuePair, singleValue)
}
const tags = () => store.getters['tenant/getExistingTags'].map(c => ({ value: c.uuid, label: c.label }))

const setFilterGenericProcess = (arg, keyValuePair, processType = 'private') => {
  if (!arg) return null;
  const config = store.getters['tenant/getProcessesConfig'];

  if (!config?.[processType]?.steps) return;

  const step = config[processType].steps.find(s => s.form.some(element => element.fields?.[arg]))
  const component = step.form.find(element => element.fields?.[arg]);

  if (!component) return;

  if (keyValuePair) {
    return component.fields[arg].options.map(option => ({ value: option.value, label: option.text }));
  }
  return component.fields[arg].options.map(option => option.text);
}

const processStepLabels = () => store.getters['tenant/getProcessStepLabels']

export default {
  setFilterOptions: ({ facetField, facets }) => {
    if (!facetOptions[facetField]) return false

    return facetOptions[facetField]({ facets })
  },
  setDate: ({ fieldValue }) => {
    const date = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue
    return (fieldValue && fieldValue !== 'Cancelled') ? new Date(date).toLocaleDateString('es-CL') : '-'
  },

  setPostalCode: ({ fieldValue }) => {
    return fieldValue ? fieldValue.replace(/\s/g, '').replace(/\d{4}/, '$& ') : '-'
  },

  // setMunicipalityFromStakeholder: ({ record }) => {
  //   const municipality = record.stakeholders.find(s => s.category === 'municipality')
  //   console.log({ value: record.MunicipalityCode, text: municipality.name })
  //   return { value: record.MunicipalityCode, text: municipality.name }
  // },

  setContractor: ({ fieldValue, record }) => {
    // Asset processes => custom processes //
    const isCustomeProcess = ['brussels', 'wallonia', 'takeover'].includes(record?.type)
    if (isCustomeProcess) {
      const contractor = record.recordMetaData?.stakeholders?.find(stakeholder => stakeholder.category === 'contractor')
      return fieldValue ? contractor?.name : '-'
    }
    return fieldValue ? store.getters['tenant/getContractorByUuid']({ uuid: fieldValue })?.label : '-'
  },

  setCpo: ({ fieldValue }) => {
    const cpos = store.getters['tenant/getCpos'].map(cpo => ({ value: (cpo.uuid || cpo.value), label: (cpo.name || cpo.text) }))
    const cpo = cpos.find(cpo => cpo.value === fieldValue)
    return (fieldValue && cpo) ? (cpo.label || cpo.text) : '-'
  },

  setLink: ({ process }) => {
    const uuid = process.processUuid
    const name = process.type === 'realisation' ? 'Realisation' : 'Process'

    uuid && router.push({ name, params: { uuid } })
  },

  setProcessType: ({ fieldValue }) => {
    return i18n.t(`processTypes.${fieldValue}`)
  },

  setMunicipalitiesDropdown: () => {
    const municipalities = store.getters['tenant/getMunicipalityOptions']
    const options = municipalities.filter(mun => mun.text).map(mun => ({ value: mun.value, label: mun.text }))

    return sort(options, true)
  },

  // setMunicipalitiesDropdown: (keyValuePair, column) => {
  //   console.log(keyValuePair, column)
  //   return setMunicipalitiesDropdown('label')
  // },
  setMunicipalityValue: ({ fieldValue }) => {
    return municipalityOptions(true).find(mun => mun.value === fieldValue)?.label
  },

  setCurrentStep: ({ fieldValue, record }) => {
    const isManualOrImport = ['manual', 'import'].includes(record.type)
    const status = isManualOrImport ? fieldValue : record.processStatus?.status
    const statusLabel = isManualOrImport ? i18n.t(`processStatus.${status}`) : '(' + i18n.t(`processStatus.${status}`) + ')'

    return `${!isManualOrImport ? fieldValue : ''} ${statusLabel}`
  },

  setCustomerValue: ({ fieldValue }) => {
    const options = setFilterGenericProcess('Customer', true)
    const customer = options?.find(customer => customer.value === fieldValue)

    return fieldValue && customer ? (customer.label[i18n.locale] || customer.label) : '-'
  },

  setBooleanYesNoValue: ({ fieldValue }) => {
    return fieldValue ? i18n.t('yes') : i18n.t('no')
  },

  setBooleanYesNoDropdown: () => {
    return [{ value: true, label: i18n.t('yes') }, { value: false, label: i18n.t('no') }]
  },

  setStepValue: ({ fieldValue, record }) => {
    const processType = record.processType.value
    const stepLabels = processStepLabels()[processType]
    const step = stepLabels[record.currentStep - 1]

    return fieldValue === 100
      ? `${stepLabels.length} ${i18n.t('processes.completed')}`
      : `${record.currentStep} ${(step.label?.[i18n.locale] || step.label)}`
  },

  setStepsDropdown: () => {
    const processSteps = store.getters['tenant/getSteps'].map(step => ({ value: step.step, label: `${step.step} ${step.label[i18n.locale] || step.label}` }))
    const last = store.getters['tenant/getSteps'].at(-1)
    processSteps.push({ value: 100, label: `${last.step} ${i18n.t('processes.completed')}` })

    return processSteps
  },

  setStakeholderValue: ({ fieldValue }) => {
    const stakeholders = store.getters['tenant/getTenantStakeholders']
    const stakeholder = stakeholders({ category: null }).find(stakeholder => stakeholder.uuid === fieldValue)?.name
    return stakeholder
  },

   setStakeholderDropdown: (keyValuePair, column) => {
    const stakeholders = store.getters['tenant/getTenantStakeholders']
    return stakeholders({ category: column.field }).map(stakeholder => ({ value: stakeholder.uuid, label: stakeholder.name }))
  },

  setCpoValue: ({ fieldValue }) => {
    const cpo = store.getters['tenant/getCpos'].find(cpo => cpo.value === fieldValue)?.text
    return cpo
  },

  setGridOperatorValue: ({ fieldValue }) => {
    const gridoperator = store.getters['tenant/getGridOperators'].find(op => op.value === fieldValue)?.text
    return gridoperator
  },

  setCposDropdown: () => {
    return store.getters['tenant/getCpos'].map(cpo => ({ value: cpo.value, label: cpo.text }))
  },

  setPidValue: ({ fieldValue }) => {
    const pidValue = store.getters['tenant/getEnabledPids'].find(pid => pid.uuid === fieldValue)?.label
    return pidValue
  },

  setPidDropdown: () => {
    return store.getters['tenant/getEnabledPids'].map(pid => ({ value: pid.uuid, label: pid.label }))
  },

  setCustomerDropdown: () => {
    return setFilterGenericProcess('Customer', true)
  },

  setObjectManagerDropdown: () => {
    return setFilterGenericProcess('ObjectManager', true)
  },

  setAssetManagerDropdown: () => {
    return setFilterGenericProcess('AssetManager', true)
  },

  setRegionalProjectLeaderValue: ({ fieldValue }) => {
    // Atm. until the migration of RPL (auth0 id => name) is done, value or label is used //
    const rplValue = store.getters['tenant/getRegionalProjectLeaders'].find(rpl => [rpl.value, rpl.label].includes(fieldValue))?.label
    return rplValue
  },

  setRegionalProjectLeaderDropdown: () => {
    return sort(store.getters['tenant/getRegionalProjectLeaders'], true)
  },

  setTagsDropdown: () => tags(),
  setTagValue: ({ record }) => {
    return store.getters['tenant/getExistingTags']
      .filter(tag => record.Tags?.includes(tag.uuid))
      .map(tag => tag.label)
      .join(', ')
  },

  setAddressValue: ({ fieldValue }) => { //address as a object //
    const { street, streetNumber, streetNumberSuffix, postalCode, city, country } = fieldValue
    return `${street} ${streetNumber}${streetNumberSuffix ? streetNumberSuffix + ',' : ','} ${postalCode}${city ? ', ' + city : ''}${country ? ', '+ country : ''} `
  },

  setChargingPointStatusValue: ({ fieldValue }) => {
    const statuses = store.getters['tenant/getChargingpointStatuses']
    return statuses.find(status => status.value === fieldValue)?.label[i18n.locale]
  },

  setChargingPointStatusesDropdown: () => {
    const statuses = store.getters['tenant/getChargingpointStatuses']
    return statuses.sort(((a, b) => a.label[i18n.locale].localeCompare(b.label[i18n.locale])))
  },

  setStatusValue: ({ fieldValue }) => { // fieldValue = status {} //
    const validStatuses = ['completed', 'cancelled', 'onhold']
    const status = Object.keys(fieldValue).filter(status => validStatuses.includes(status)).find(status => fieldValue[status]) || 'active';
    return i18n.t(`processes.statusFilters.${status === 'vkb' ? 'active' : status}`)
  },

  setCurrentStatusMessageValue: ({ fieldValue }) => { // fieldValue = statusMeta {} //
    if (!fieldValue) return;

    const municipalityFeedback = fieldValue.cancelled?.reason === 'municipality-feedback'
    const otherReasonWithComment = ['cancelled', 'onhold'].some(type => {
      return fieldValue?.[type] && fieldValue[type].reason === 'other' && fieldValue[type].comment?.length
    })
    const cancelComment = municipalityFeedback
      ? i18n.t('processes.messages.municipalityFeedback')
      : fieldValue.cancelled?.comment

    let currentStatusMessage =
      [...store.getters['tenant/getOnHoldReasons'], ...store.getters['tenant/getCancelReasons']].find(
        reason => (fieldValue.cancelled?.reason || fieldValue.onhold?.reason) === reason.value
      )?.text

    if (otherReasonWithComment && currentStatusMessage) {
      currentStatusMessage = `${currentStatusMessage} (${fieldValue.cancelled?.comment || fieldValue.onhold?.comment})`
    }

    return currentStatusMessage || cancelComment
  },

  setCpos,

  setCategoryValue: ({ fieldValue }) => {
    const processType = store.getters['processes/getCurrentProcessType']
    const hasProcessCategory = ['realisation', 'brussels', 'wallonia', 'takeover'].includes(processType)
    const category = store.getters['tenant/getCategoryOptions'].find(cat => cat.value === fieldValue)?.text
    if (!hasProcessCategory || !category) return ''

    const isDutch = i18n.locale === 'nl'
    const translationPath = 'processes.sidebar.process_categories'
    return isDutch ? category : i18n.t(`${translationPath}.${fieldValue}`) || fieldValue
  },

  setCategoriesDropdown: () => {
    const isDutch = i18n.locale === 'nl'
    const translationPath = 'processes.sidebar.process_categories'
    const categories = store.getters['tenant/getCategoryOptions']
      .map(cat => ({
        value: cat.value,
        label: isDutch ? cat.text : i18n.t(`${translationPath}.${cat.value}`)
      }))

    return categories
  },

  setVkbValue: ({ fieldValue, record }) => {
    const vkb = store.getters['tenant/getVkbStatuses'].find(status => status.value === fieldValue)
    return record.currentStatus.vkb ? i18n.t('vkbStatuses.vkb') : vkb ? i18n.t(`vkbStatuses.${vkb}`) : '' //|| fieldValue
  },

  setVkbDropdown: () => {
    const vkbStatuses = sort(store.getters['tenant/getVkbStatuses']).map(status => ({ value: status, label: status }))
    //console.log(vkbStatuses)
    return vkbStatuses
  },

  setFinUnitValue: ({ fieldValue }) => {
    return SPV[fieldValue]
  },

  setFinUnitsDropdown: () => {
    const spvUnits = Object.keys(SPV).map(unit => ({ value: unit, label: SPV[unit] }))

    return spvUnits
  },

  setScenarioValue: ({ fieldValue }) => {
    const options = setFilterGenericProcess('scenario', true, 'wallonia')
    const option = options.find(opt => opt.value === fieldValue)

    return option?.label?.[i18n.locale] || option?.label
  },

  setScenarioDropdown: () => {
    return setFilterGenericProcess('scenario', true, 'wallonia')
  },

  setManufacturerValue: ({ fieldValue }) => {
    const options = setFilterGenericProcess('manufacturer', true, 'wallonia')
    const option = options.find(opt => opt.value === fieldValue)

    return option?.label?.[i18n.locale] || option?.label
  },

  setManufacturerDropdown: () => {
    return setFilterGenericProcess('manufacturer', true, 'wallonia')
  },

   setCurrentRatingValue: ({ fieldValue }) => {
    const options = setFilterGenericProcess('currentRating', true, 'wallonia')
    const option = options.find(opt => opt.value === fieldValue)

    return option?.label?.[i18n.locale] || option?.label
  },

  setCurrentRatingDropdown: () => {
    return setFilterGenericProcess('currentRating', true, 'wallonia')
  },

  setGridOperatorsDropdown: () => {
    const gridOperators = store.getters['tenant/getGridOperators'].map(op => ({ value: op.value, label: op.text }))
    return sort(gridOperators, true)
  },

  setGridOperatorsFromMunicipalities,

  // setConnectionValue: ({ fieldsValue }) => {
  //   const value = gridConnectionValues
  // },

  setConnectionsDropdown: () => {
   return gridConnectionValues.map(val => ({ value: val, label: val }))
  },

  setChargingStationVersionsDropdown: () => {
    const charchingStationVersions = store.getters['tenant/getCharchingStationVersions'].map(val => ({ value: val, label: val }))
    return sort(charchingStationVersions, true)
  },

  setPowerTypesDropdown: () => {
    const powerType = ['AC', 'DC'].map(val => ({ value: val, label: val }))
    return sort(powerType, true)
  },

  setContractorValue: ({ fieldValue }) => {
    const contractor = store.getters['tenant/getEnabledContractors'].find(contractor => contractor.uuid === fieldValue)
    return contractor?.label
  },

  setQRCodeValue: ({ fieldValue }) => {
    // Export only atm. //
    return fieldValue?.join(', ') || ''
  },

  setContractorsDropdown: () => {
    const contractors = store.getters['tenant/getEnabledContractors'].map(c => ({ value: c.uuid, label: c.label }))

    return sort(contractors, true)
  },

  setContractorsFromStakeholders,

  setTypeOfChargingStationValue: ({ fieldValue }) => {
    const options = setFilterGenericProcess('typeOfChargingStation', true, 'brussels')
    const option = options.find(opt => opt.value === fieldValue)

    return option?.label?.[i18n.locale] || option?.label
  },

  setTypeOfChargingStationDropdown: () => {
    return setFilterGenericProcess('typeOfChargingStation', true, 'brussels')
  },

  setWorkflowUserValue: ({ fieldValue }) => {
    const user = store.getters['tenant/getWorkflowUsers'].find(user => user.user_id === fieldValue)
    return user?.name
  },

  setTenantUsersDropdown: () => {
    const users = store.getters['tenant/getWorkflowUsers']
    const userList = users.map(user => ({ value: user.user_id, label: user.name }))

    return sort(userList, true)
  },

  setWorkflowUsersDropdown,

  setTypeOfParkingSpaceValue: ({ fieldValue }) => {
    const ParkingLocation = setFilterGenericProcess('ParkingLocation', true)
    const ParkingAccessibility = setFilterGenericProcess('ParkingAccessibility', true)
    const hasFieldValue = fieldValue && fieldValue?.some(field => Object.values(field).filter(Boolean).length)

    if (hasFieldValue) {
      const value = fieldValue.map(val => {
        const location = ParkingLocation.find(loc => loc.value === val.ParkingLocation)?.label?.[i18n.locale] || ''
        const accessibillity = ParkingAccessibility.find(loc => loc.value === val.ParkingAccessibility)?.label?.[i18n.locale] || ''
        const separator = location && accessibillity ? ' => ' : ''

        return `${location}${separator}${accessibillity}`
      })

      return value.join(' || ')
    }
    return ''
  },

  setFilterGenericProcess: arg => setFilterGenericProcess(arg),

  setGridOperatorAddress: ({ fieldValue }) => {
   if (fieldValue && fieldValue?.StreetName) {
     return `${fieldValue?.StreetName} ${fieldValue?.HouseNumber}${fieldValue?.HouseNumberSuffix}, ${fieldValue?.PostalCode} ${fieldValue?.CityName}`
   }
   return fieldValue
  },

  setCommaSeparatedString: ({ fieldValue }) => {
    return (fieldValue || []).join(', ')
  },

  setComments: ({ record }) => {
    const comments = record.comments
      ?.sort((a, b) => b.created_at - a.created_at)
      .map(comment => {
        if (!comment.deleted_at && !/^test|verwijder/i.test(comment.Message)) {
          return comment.Message
        }
      })
      .filter(Boolean)
      .join(' || ')

    return comments
  },
  // value-label based option filters (dropdowns) //
  tags: () => tags(),
  setTagLabels: () => tags(),
  //

  // Field name based functions (LocationList)
  city: () => municipalityOptions(),
  municipality: (keyValuePair, singleValue) => municipality(keyValuePair, singleValue), // Set flag for options key-value pair in needed (requests) //
  finUnit: ({ textProp = 'label' }) => {
    return Object.keys(SPV).map(key => ({ value: key, [textProp]: SPV[key] }))
  },
  domain: ({ textProp = 'label' }) => {
    return [
      { value: 'public', [textProp]: i18n.t('recordList.public') },
      { value: 'private', [textProp]: i18n.t('recordList.private') }
    ]
  },
  gridOperator: () => {
    return sort(getGridOperators().map(op => ({ value: op.value, label: op.text })), true, 'label')
  },
  gridConnectionValue: () => gridConnectionValues.map(value => ({ value, label: value })),
  //

  setMunicipalityOptions: () => municipalityOptions(),
  setCpoOptions: () => sort(store.getters['tenant/getCpos'].map(cpo => cpo.text)),
  setChargingpointStatuses: () => sort(store.getters['tenant/getChargingpointStatuses']),
  setCategoryOptions: () => sort(store.getters['tenant/getCategoryOptions'].map(c => c.text)),
  setGridConnectionValues: ({ textProp = 'label' } = {}) => gridConnectionValues.map(value => ({ value, [textProp]: value })),
  setCharchingStationVersions,
  setContractors: () => sort(store.getters['tenant/getEnabledContractors'].map(c => c.label)),
  setTagOptions: () => sort(store.getters['tenant/getExistingTags'].map(c => c.label)),
  setFinUnitOptions: () => sort(finUnit),
  setStatusOptions: () => ['Actief', 'On hold', 'Afgerond', 'Geannuleerd'],
  setPowerTypeOptions: () => ['AC', 'DC'],
  setVkbStatusOptions: () => sort(store.getters['tenant/getVkbStatuses'])
}
